import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';

import { useTranslation } from 'react-i18next';
import FormPayment from '@/components/Subscription/FormSub/Form/Payment';
import Cart from '@/components/Subscription/FormSub/Cart';
import './index.scss';

function Payment({ data, cusInfo, onSubmit, onBack }) {
  const { t } = useTranslation();
  return (
    <div className="form-payment">
      <Row gutter={[16, 24]} className="form-subscribe__group">
        <Col lg={{ span: 15 }} span={24}>
          <div className="form-subscribe__title --done">
            <div className="d-flex justify-content-between align-center">
              <div className="form-subscribe__title__group">
                <span className="form-subscribe__step --done" />
                <div className="form-payment__customer">
                  <h3>{t('subscribe_customer_info.title')}</h3>
                  <p className="form-payment__customer__info">{cusInfo}</p>
                </div>
              </div>
              <span
                className="form-payment__edit"
                role="button"
                aria-hidden="true"
                onClick={onBack}
              />
            </div>
          </div>
          <div className="form-subscribe__title form-subscribe__title__group">
            <span className="form-subscribe__step --empty">2</span>
            <h3>{t('subscriptions_page.payment.page_title')}</h3>
          </div>
          <FormPayment onSubmit={onSubmit} />
        </Col>
        <Col lg={{ span: 9 }} span={24}>
          <Cart data={data} />
        </Col>
      </Row>
    </div>
  );
}

Payment.propTypes = {
  data: PropTypes.object,
  cusInfo: PropTypes.string,
  onSubmit: PropTypes.func,
  onBack: PropTypes.func,
};

export default Payment;
